import { useGetFcos } from '../../../api/fcos';
import { WorkspaceFCOContainer } from '../../../core/types/fcoTypes';
import { useUserSettings } from '../../context/UserSettingsContext';

// @tecton
import { Empty, Loading, ViewLayout } from '@lithos';
import FeatureServicesList from './FeatureServicesList';
import { TECTON_DOCUMENTATION_LINKS } from '../../redesign/application-links';

export const FeatureServicesContainer = () => {
  const { workspace } = useUserSettings();

  const { data, isError, isLoading } = useGetFcos<WorkspaceFCOContainer>(workspace as string, {
    select: (data: WorkspaceFCOContainer) => {
      return {
        featureServices: data?.featureServices ?? [],
        idToFcoMap: data.idToFcoMap,
      };
    },
  });

  const headerProps = {
    breadcrumbs: {
      root: { label: workspace ?? '', url: `/repo/${workspace}` },
      items: [{ label: 'Services', url: `/repo/${workspace}/services` }],
    },
    title: 'Services',
    subtitle: 'Feature Services group features from Feature Views together for training and serving.',
    learnMoreLink: TECTON_DOCUMENTATION_LINKS.FEATURE_SERVICES,
  };

  if (isLoading) {
    return <ViewLayout header={headerProps} content={<Loading />} />;
  }

  if (isError) {
    return (
      <ViewLayout
        header={headerProps}
        content={
          <Empty
            title={<>Error Loading Feature Services</>}
            description={<>There was an error loading Feature Services for this workspace. Please try again.</>}
            useCase="errorUnknown"
            placement="full-page"
            actions={undefined}
          />
        }
      />
    );
  }

  return (
    <ViewLayout
      header={headerProps}
      content={
        <FeatureServicesList
          items={data?.featureServices ?? []}
          idToFcoMap={data?.idToFcoMap}
          workspace={workspace ?? ''}
        />
      }
    />
  );
};

export default FeatureServicesContainer;
